/**
 * Route for `agent-driven-campaign-optimization-ai-native`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AgentDrivenCampaignOptimizationAiNativePage } from "../features/agent-driven-campaign-optimization-ai-native/AgentDrivenCampaignOptimizationAiNativePage";

export const agentDrivenCampaignOptimizationAiNativeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/agent-driven-campaign-optimization-ai-native",
	component: AgentDrivenCampaignOptimizationAiNativePage,
});

export default agentDrivenCampaignOptimizationAiNativeRoute;
